import React from 'react'
import { FC } from 'react'
import { ICoverageMap } from './types'
import Iframe from '../LinkConverter/components/Iframe'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

const style = {
  borderStyle: {
    borderRadius: '6px',
  },
}
const CoverageMap: FC<ICoverageMap> = ({ variant }) => {
  const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'))
  const mapSrc = `https://daekning.tdc.dk/tdcnetmap_ext_tile2/?center=&zoom=0&tema=${variant === 'driftsinfo' ? 'affected_open' : ''}`
  return (
    <>
      <Iframe
        linkHref={mapSrc}
        allowFullScreen={true}
        title={`${variant === 'driftsinfo' ? 'Drifts Info Map' : 'Coverage Map'}`}
        frameBorder="0"
        style={style.borderStyle}
        {...(isMobile ? { height: 380 } : {})}
      />
    </>
  )
}
export default CoverageMap
